import type { CustomCellRendererProps } from 'ag-grid-react';
import { useTranslation } from 'react-i18next';

import { SavingType, type SavingsListQuery } from '@/generated/gql/graphql';

type SavingsListRow = SavingsListQuery['savings'][number];

export const SavingTypeCellRenderer = ({ value }: CustomCellRendererProps<SavingsListRow, SavingType | null>) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'Savings.savingType' });

  if (!value) return null;

  return <>{t(value)}</>;
};
